module.exports = __webpack_public_path__ + "static/media/logoWithBox.919e79fb.svg";